import { render } from "./animationBox.vue?vue&type=template&id=765c35c4&scoped=true"
import script from "./animationBox.vue?vue&type=script&lang=js"
export * from "./animationBox.vue?vue&type=script&lang=js"

import "./animationBox.vue?vue&type=style&index=0&id=765c35c4&scoped=true&lang=css"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-765c35c4"]])

export default __exports__